var exports = $.extend({}, require('core/search/search'));
var SiteConstants = require('constants/SiteConstants');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results, selector) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });
    updateDom($results, selector);
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var isMobile = window.isMobile();

    if (isMobile) {
        var $refinements = $results.find('.refinements[data-refinement-style-mobile]');
        var refinementStyle = $refinements.data('refinement-style-mobile');
        var selector = `[data-refinement-style-mobile="${refinementStyle}"]`;
    } else {
        var $refinements = $results.find('.refinements[data-refinement-style-desktop]');
        var refinementStyle = $refinements.data('refinement-style-desktop');
        var selector = `[data-refinement-style-desktop="${refinementStyle}"]`;
    };

    var $filterBar = $results.find('.filter-bar');
    var filterBarStyle = !isMobile ? $filterBar.attr('data-filter-bar-style-desktop') : $filterBar.attr('data-filter-bar-style-mobile');
    var filterBar = !isMobile ? '[data-filter-bar-style-desktop="' + filterBarStyle + '"]' : '[data-filter-bar-style-mobile="' + filterBarStyle + '"]';

    var verticalMobile = isMobile && selector === '[data-refinement-style-mobile="vertical"]';
    var verticalDesktop = !isMobile && selector === '[data-refinement-style-desktop="vertical"]';
    var horizontalMultipleDropdownsDesktop = !isMobile && selector === '[data-refinement-style-desktop="horizontal-multiple-dropdowns"]';
    var horizontalOneDropdownDesktop = !isMobile && selector === '[data-refinement-style-desktop="horizontal-one-dropdown"]';
    var horizontalOneDropdownDesktopActive = $('.collapse-filters-wrapper').hasClass('active');
    var horizontalOneDropdownDesktopOpen = false;

    if (horizontalOneDropdownDesktop && horizontalOneDropdownDesktopActive) {
        horizontalOneDropdownDesktopOpen = true;
    }

    if (verticalMobile || verticalDesktop) {
        var specialHandlers = {
            selector : handleRefinements
        };

        Object.keys(specialHandlers).forEach(function (selector) {
            specialHandlers[selector]($results, selector);
        });
    };

    if (!isMobile) {
        var refinements = '.desktop-search-refinements';
    } else {
        var refinements = '.mobile-search-refinements';
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.view-header',
        '.result-count',
        refinements,
        filterBar
    ].forEach((selector) => {
        updateDom($results, selector);
    });

    // This will handle the breaking of the dropdown after ajax
    if (horizontalMultipleDropdownsDesktop) {
        var $dropdownMenu = $('.dropdown:not(.disabled)');

        $dropdownMenu.on("mouseenter",function(){
            $(this).addClass('show');
            $(this).find('.dropdown-menu').addClass('show');
        });

        $dropdownMenu.on("mouseleave",function() {
            $(this).removeClass('show');
            $(this).find('.dropdown-menu').removeClass('show');
        });
    };

    if (horizontalOneDropdownDesktopOpen === true) {
        $('.collapse-filters-wrapper').addClass('active').css('display', 'block');
    }

    $('body').trigger('ajax:load.ajaxEvents', [$('.search-results')]);

    exports.refinementStickyBar();
    exports.oneDropdownSlideToggle();
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        $('option.' + option.id).val(option.url);
    });
}

// This will update a URL param with a new value
// or if the param is not present, it will add it
function replaceUrlParam(url, key, value) {
    let urlParts = url.split('?');
    let params = urlParts[1] ? urlParts[1].split('&') : '';
    if (params.length > 0) {
        const paramRegEx = new RegExp('^' + key + '=');
        params.forEach(function(param) {
            if (paramRegEx.test(param)) {
                params.pop(param);
            }
        });
        params = params.join('&');
        params += '&';
    }
    params += key + '=' + value;
    const newUrl = [urlParts[0], params].join('?');
    return newUrl;
}


exports.updateItemsPerPage = function () {
    // Handle number of products displayed per page
    $('body').on('change', '[name=items-per-page]', event => {
        const $el = $(event.target);
        const numPerPage = $el.val();
        const url = $el.data('url');

        $.spinner().start();

        $.ajax({
            url: url,
            data: {
                page: $('.grid-footer').data('page-number'),
                sz: numPerPage,
                selectedUrl: url
            },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                const newUrl = replaceUrlParam(url, 'sz', numPerPage);
                history.replaceState(undefined, '', newUrl);
                $('body').trigger('search:updateItemsPerPage--success');
                $.spinner().stop();
            },
            complete: function () {
                $.spinner().stop();
            }
        });
    });
};

exports.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', event => {
        event.preventDefault();
        const $el = $(event.target);
        const url = $el.val();
        $.spinner().start();

        $(this).trigger('search:sort', url);

        $.ajax({
            url: url,
            data: { selectedUrl: url },
            method: 'GET',
            success: function (response) {
                parseResults(response);
                history.replaceState(undefined, '', url);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

exports.addClickedParam = function () {
    $('body').on('click', '.product *', function () {
        const clickedPID = $(this).closest('.product').data('pid');
        if (clickedPID) {
            let currentURL = new URL(window.location.href);
            currentURL.searchParams.set('clicked', clickedPID);
            window.history.pushState({}, '', currentURL.toString())
        }
    });
}

exports.goToClickedProduct = function () {
    $(window).on('load', function () {
        let currentURL = new URL(window.location.href);
        let clicked = currentURL.searchParams.get('clicked');
        if (clicked) {
            var selector = '.product-tile[data-pid="' + clicked + '"]';
            document.querySelector(selector).scrollIntoView();
        }
    })
}

exports.showMore = function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        var $resultsContainer = $(event.target).closest('.search-results');
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        const sortOptions = $(this).closest('.grid-footer').data('sort-options').options;
        let relevanceURL = new URL(window.location.href);
        const sRule = relevanceURL.searchParams.get('srule');
        if (!relevanceURL.searchParams.get('sz')) {
            sortOptions.forEach((option) => {
                if (sRule && sRule === option.sortingRuleId) {
                    relevanceURL = new URL(option.url);
                    return;
                } else if (option.id == "relevanceSorting" || option.sortingRuleId == "Default") {
                    relevanceURL = new URL(option.url);
                    return;
                }
            });
        }

        const currentSize = relevanceURL.searchParams.get('sz')
        if (currentSize) {
            const increaseAmount = $('select[name="items-per-page"]').length > 0 && $('select[name="items-per-page"]').val() ? Number($('select[name="items-per-page"]').val()) : 12
            const updatedSize = Number(currentSize) + increaseAmount;
            relevanceURL.searchParams.set('sz', updatedSize);
        }

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                updateSortOptions(response);
                $('body').trigger('search:showMore--success');
                window.history.pushState({}, '', relevanceURL.toString())

                // update visible results count
                if ($resultsContainer.length) {
                    var $visibleResultCount = $resultsContainer.find('.visible-result-count');
                    var resultsLength = $resultsContainer.find('.product-grid .product').length;
                    $visibleResultCount.text(resultsLength);
                }

                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

exports.applyFilter = function () {
    var $xhr;
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li button, .refinement-bar button.reset, .filter-value:not(.not-a-real-filter) button, .swatch-filter button',
        function (event) {
            var category = $(event.currentTarget).closest('.refinement');

            if (category && category.hasClass('refinement-category')) {
                localStorage.setItem('refinement-category', true);
                return;
            }
            // this seemingly not needed and was prepending an srule on the reset URL
            // but it should all get picked up by the session.custom values
            // - find new attr on Sort if selected, if not use the default
            // var selectedSort = $('select[name="sort-order"]').find('option[selected="selected"]');
            // if (selectedSort.data('id') != null) {
            //     var sortingRule = selectedSort.data('id');
            // } else {
            //     var sortingRule = $('select[name="sort-order"] option:selected').data('id');
            // }
            //create a new url with the correct preferences
            // var refinementUrl = replaceUrlParam($(this).data('href'), 'srule', sortingRule);
            var refinementUrl = $(this).data('href');
            event.preventDefault();
            event.stopPropagation();

            $(this).trigger('search:filter', event);

            // Cancel previous request
            $xhr && $xhr.abort && $xhr.abort();

            $xhr = $.ajax({
                url: refinementUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: refinementUrl
                },
                method: 'GET',
                timeout: 10000,
                beforeSend: function () {
                    $.spinner().start();
                },
                success: function (response) {
                    parseResults(response);
                    history.replaceState(undefined, '', refinementUrl);
                    $('body').trigger('search:filter--success');
                },
                complete: function () {
                    $.spinner().stop();
                }
            });
        });
};

// keep refinement header visible on mobile, so user always has a way to close it
exports.fixMobileRefinementHeader = function() {
    if (window.isMobile()) {
        var $filterHeader = $('.refinement-bar .filter-header .header-bar');

        $('.refinement-bar').scroll(function(event) {
            $filterHeader.css('top', '');
            clearTimeout($.data(this, 'scrollTimer'));

            $.data(this, 'scrollTimer', setTimeout(function() {
                var scrollTop = $(event.target).scrollTop();
                if (scrollTop > 0) {
                    $filterHeader.css('top', scrollTop);
                } else {
                    $filterHeader.css('top', '');
                }
            }, 250));
        });
    };
};

var closeOneRefinementsDropdown = (e) => {
    var $oneRefinementsDropdown = $('.horizontal-onedropdown-filter-group');
    if ((!$('.collapse-one-dropdown-filter').is(e.target) && $oneRefinementsDropdown.has(e.target).length === 0)
        || $('.close-one-refinements-dropdown').is(e.target)) {
            $('.collapse-filters-wrapper').slideUp().removeClass('active');
    }
};

var toggleRefinementDrawer = status => {
    var $refinementBar = $('.refinement-bar');
    var $modalBackground = $('.modal-background');

    if (status === 'open') {
        var $header = $('header');
        var headerNavHeight = $header.outerHeight();
        var scrollTopHeight = $header.offset().top;
        $('html').scrollTop(scrollTopHeight);
        // Following two lines for MS Edge to work
        document.body.scrollTop = scrollTopHeight;
        document.documentElement.scrollTop = scrollTopHeight;
        $('html, body').addClass('lock-scroll');
        $('body').addClass('mobile-filter-drawer-in');
        $refinementBar.addClass('in').css('top', headerNavHeight).siblings().attr('aria-hidden', true);
        $modalBackground.fadeIn(SiteConstants.TransitionSpeed).css('top', headerNavHeight);
        $refinementBar.closest('.row').siblings().attr('aria-hidden', true);
        $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', true);
        $refinementBar.find('.apply-filters').focus();
    } else {
        $('html, body').removeClass('lock-scroll');
        $('body').removeClass('mobile-filter-drawer-in');
        $refinementBar.removeClass('in').css('top', '').siblings().attr('aria-hidden', false);
        $modalBackground.fadeOut(SiteConstants.TransitionSpeed);
        $refinementBar.closest('.row').siblings().attr('aria-hidden', false);
        $refinementBar.closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $refinementBar.closest('.container.search-results').siblings().attr('aria-hidden', false);
        $('.btn.filter-results').focus();
    }
};

// adjusting refinements close to use different button class
exports.closeRefinements = function () {
    $('html').on('click', '.refinement-bar button.apply-filters, .mobile-filter-drawer-in .modal-background', () => toggleRefinementDrawer('close'));
    //for horizontal one dropdown menu
    $('html').on('click', (e) => closeOneRefinementsDropdown(e));
}

module.exports = exports;
